import clsx from 'clsx'
import type { ReactNode } from 'react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { applicantModalNavButton } from '~/components/Scopes/Applicants/ApplicantModal/ApplicantModal.css'

export type ApplicantNavDetailsProps = {
  name: string
  onClick?: () => void
  className?: string
  children?: ReactNode
}

export const ApplicantNavDetails = ({
  name,
  onClick,
  className,
  children
}: ApplicantNavDetailsProps) => (
  <Tooltip text={name} direction="top" asChild>
    <span
      onClick={onClick}
      className={clsx(applicantModalNavButton, className)}
    >
      {children}
    </span>
  </Tooltip>
)
